// extracted by mini-css-extract-plugin
export default {"navTabMenuHeader":"navTabMenuHeader_navTabMenuHeader__VbiH5"};